import { render, staticRenderFns } from "./double-bed.vue?vue&type=template&id=78704047&scoped=true"
import script from "./double-bed.vue?vue&type=script&lang=js"
export * from "./double-bed.vue?vue&type=script&lang=js"
import style0 from "./double-bed.vue?vue&type=style&index=0&id=78704047&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78704047",
  null
  
)

export default component.exports